import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = ClassAttributes<HTMLElement> & {
  onClickAcceptButton: MouseEventHandler<HTMLElement>;
  onRequestClose: MouseEventHandler<HTMLElement>;
  open?: boolean;
  className?: string;
};

const ModificationRequestApproveDialog = ({ onClickAcceptButton, onRequestClose, open, className, key }: Props) => {
  const ariaLabelledBy = `draft-project-delete-dialog-title-${key}`;
  const ariaDesscribedBy = `draft-project-delete-dialog-description-${key}`;

  return (
    <Dialog
      open={!!open}
      onClose={onRequestClose}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDesscribedBy}
      className={className}
    >
      <DialogTitle id={ariaLabelledBy}>
        <FormattedMessage id="modification_request.approve_dialog.title" />
      </DialogTitle>

      <DialogContent>
        <DialogContentText id={ariaDesscribedBy}>
          <FormattedMessage id="modification_request.approve_dialog.description" />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onRequestClose}>
          <FormattedMessage id="modification_request.approve_dialog.decline" />
        </Button>

        <Button onClick={onClickAcceptButton} autoFocus>
          <FormattedMessage id="modification_request.approve_dialog.accept" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModificationRequestApproveDialog;
